<div class="pg">
  <div class="pg-stage">
    <div class="pg-toolbar">
      <div class="pg-legend">
        <button type="button" class="pg-chip" [class.off]="!show().flow" (click)="toggle('flow')">
          <i class="pg-dot" [style.background]="colors.flow"></i> Flows
        </button>
        <button type="button" class="pg-chip" [class.off]="!show().step" (click)="toggle('step')">
          <i class="pg-dot" [style.background]="colors.step"></i> Steps
        </button>
        <button type="button" class="pg-chip" [class.off]="!show().policy" (click)="toggle('policy')">
          <i class="pg-dot" [style.background]="colors.policy"></i> Policies
        </button>
      </div>

      <div class="pg-filter">
        <select
          class="pg-select"
          [ngModel]="flowFilter() ?? ''"
          (ngModelChange)="onFlowFilterChange($event)"
          aria-label="filter by flow"
        >
          <option value="">All flows</option>
          <option *ngFor="let f of flowOptions()" [value]="f.id">{{ f.name }}</option>
        </select>
        <button type="button" class="pg-reset" (click)="resetView()">Reset view</button>
      </div>
    </div>

    <div #graphCanvas class="pg-canvas"></div>

    <div class="pg-footer">
      <span class="pg-hint">drag · scroll to zoom · click a node to focus</span>
      <span class="pg-orphan" *ngIf="!flowFilter() && orphanCount()">{{ orphanCount() }} orphan policies</span>
    </div>
  </div>

  <aside class="pg-insp">
    <ng-container *ngIf="inspected() as node; else emptyInsp">
      <div class="pg-insp-head">
        <span class="pg-insp-k" [style.background]="colors[node.kind]"></span>
        <div>
          <div class="pg-insp-title">{{ node.title }}</div>
          <div class="pg-insp-type">{{ node.kind }}</div>
        </div>
      </div>
      <div class="pg-insp-body">
        <div class="pg-insp-row" *ngFor="let m of node.meta">
          <div class="pg-insp-lbl">{{ m.label }}</div>
          <div class="pg-insp-val">{{ m.value }}</div>
        </div>
      </div>
    </ng-container>
    <ng-template #emptyInsp>
      <div class="pg-insp-empty">
        Click any node to focus it and its connections — everything else fades back.
      </div>
    </ng-template>
  </aside>
</div>
